import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class UpdatePositionRequest extends BaseUpdateRequest {
    name: string;
    description: string;
    minimumHours: number;
    industryId: string;
    skillIds: string[] = [];
    qualificationIds: string[] = [];
    uniformIds: string[] = [];
}